<mat-toolbar class="topbar">
  <button
    mat-icon-button
    class="menu-button"
    aria-label="Toggle navigation menu"
    (click)="menuClick.emit()"
  >
    <mat-icon aria-hidden="true">menu</mat-icon>
  </button>

  <a class="brand" routerLink="/" aria-label="EBP home">
    <span class="brand-mark" aria-hidden="true"><img src="pgc-logo.png" alt="" /></span>
    <span>EBP </span>
  </a>

  <span class="toolbar-spacer"></span>

  @if (auth.isAuthenticated() && auth.currentUser()) {
    <app-notification-bell />

    <div class="user-cluster">
      <button
        mat-button
        [matMenuTriggerFor]="accountMenu"
        class="profile-pill-btn"
        aria-label="Account menu"
      >
        <span class="avatar-circle" aria-hidden="true">{{ initials() }}</span>
        <span class="user-text">
          <span class="user-display-name">{{
            auth.currentUser()?.fullName || auth.currentUser()?.username
          }}</span>
          @if (designations().length) {
            <span class="user-designation">{{ designations().join(' · ') }}</span>
          }
        </span>
        <mat-icon class="pill-arrow-icon" aria-hidden="true">expand_more</mat-icon>
      </button>

      <mat-menu #accountMenu="matMenu" xPosition="before" class="topbar-account-menu">
        <div class="account-menu">
          <div class="menu-profile-card">
            <div class="menu-avatar" aria-hidden="true">{{ initials() }}</div>
            <div class="menu-user-details">
              <strong class="menu-name">{{
                auth.currentUser()?.fullName || auth.currentUser()?.username
              }}</strong>
              <span class="menu-username">{{ auth.currentUser()?.username }}</span>
              <div class="menu-badge-row">
                <span class="menu-email">{{
                  auth.currentUser()?.email || auth.currentUser()?.username
                }}</span>
                @if (context.isAdmin()) {
                  <span class="role-pill admin-pill">Administrator</span>
                }
                @for (designation of designations(); track designation) {
                  <span class="role-pill">{{ designation }}</span>
                }
                @if (auth.currentUser()?.departmentName) {
                  <span class="dept-text">{{ auth.currentUser()?.departmentName }}</span>
                }
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <button mat-menu-item (click)="logout()">
            <mat-icon aria-hidden="true">logout</mat-icon>
            <span>Sign Out</span>
          </button>
        </div>
      </mat-menu>
    </div>
  } @else {
    <a mat-button routerLink="/login" class="login-nav-btn">
      <mat-icon aria-hidden="true">login</mat-icon>
      <span>Sign In</span>
    </a>
  }
</mat-toolbar>
